import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  searchBankList,
  checkBankAccountValidation,
} from '@store/actions/eaAction';

import { showModal } from '@store/actions/commonAction';

import SatButton from '@components/common/satUI/SatButton';
import SatSignPad from '@components/common/satUI/SatSignPad';
import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatRadio from '@components/common/satUI/SatRadio';
import SatInput from '@components/common/satUI/SatInput';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import SatSelect from '@components/common/satUI/SatSelect';
import SatQuestionArea from '@components/common/satUI/SatQuestionArea';

const PolicyConversionPopup = props => {
  const {
    onClose,
    searchSignData,
    searchPasteSignData,
    signPasteData,
    onSave,
    signData,
    complete,
    bankList,
    ownerPrspCustNo,
    payerName,
    payerRsdn,
    policyConversion,
    convertTransYn,
    planInfoBankCode,
    planInfoBankName,
    planInfoAccountNo,
    isPracticeMode,
    practiceSignName,
    practiceSignature,
    applicationNo,
  } = props;

  const dispatch = useDispatch();
  const accountNumberInputRef = useRef();
  const canvasSignNameRef = useRef();
  const canvasSignatureRef = useRef();
  const reportId = 'app_form_09';

  const [showErrorCheckMsg, setShowErrorCheckMsg] = useState(false);
  const [pasteCheck, setPasteCheck] = useState(false); // 붙여넣기 체크 여부
  const [signNameData, setSignNameData] = useState(''); // 성명
  const [signatureData, setSignatureData] = useState(''); // 서명

  // const [accountType, setAccountType] = useState(
  //   convertTransYn === 'Y' ? '1' : '2',
  // );
  const [bankInfo, setBankInfo] = useState([]);
  const [accountNumber, setAccountNumber] = useState('');
  const [questionData, setQuestionData] = useState(Array(7).fill(''));
  const [checkAll, setCheckAll] = useState(false);
  const [bankCodeValid, setBankCodeValid] = useState(false);
  const [checkAccount, setCheckAccount] = useState(null);
  const [accountCheckCode, setAccountCheckCode] = useState(''); // 계좌 체크 코드
  const [accountCheckMessage, setAccountCheckMessage] = useState(''); // 계좌 체크 메시지

  useEffect(() => {
    if (bankList.length === 0) {
      dispatch(searchBankList());
    }

    if (complete) {
      if (!signData.app_form_09_signid_02 || !signData.app_form_09_signid_01) {
        // 완료된 페이지의 경우 기존 저장된 서명데이터 조회
        !isPracticeMode &&
          searchSignData(
            reportId,
            'app_form_09_signid_01',
            'app_form_09_signid_02',
          );
      }

      // setAccountType(policyConversion.accountType);
      setBankInfo(policyConversion.bankInfo);
      setAccountNumber(policyConversion.accountNumber);
      setQuestionData(Array(7).fill('Y'));
    }
    // if (accountType === '1') {
    //   //자동이체 계좌
    //   setBankInfo({ code: planInfoBankCode, name: planInfoBankName });
    //   setAccountNumber(planInfoAccountNo);
    // }
  }, []);

  useEffect(() => {
    if (checkAccount !== null && accountNumber)
      accountNumberInputRef.current.isValidCheck();
  }, [checkAccount]);

  // 붙여넣기 서명 조회
  const handlePasteCheck = value => {
    if (value && !isPracticeMode) {
      searchPasteSignData();
    }
    setPasteCheck(value);
  };

  const handleCheckBox = (findIndex, value) => {
    setQuestionData(
      questionData.map((item, index) => {
        return findIndex === index ? value : item;
      }),
    );

    if (value === 'N' && checkAll) {
      setCheckAll(false);
    }
  };

  // 계좌확인
  const onClickAccountValidEvent = () => {
    if (bankInfo.code === '' || accountNumber.length < 5) {
      if (bankInfo.code === '') setBankCodeValid(true);
      if (accountNumber.length < 5)
        accountNumberInputRef.current.isValidCheck();
    } else {
      dispatch(
        checkBankAccountValidation({
          applicationNo: applicationNo,
          bankCode: bankInfo.code,
          bankAccount: accountNumber,
          customerId: ownerPrspCustNo,
          ownerCustomerId: ownerPrspCustNo,
          callback: checkAccountCallback,
        }),
      );
    }
  };

  const checkAccountCallback = (
    result,
    accountCheckCode,
    accountCheckMessage,
  ) => {
    if (result) {
      setCheckAccount(true);
      setAccountCheckCode(accountCheckCode);
      setAccountCheckMessage(accountCheckMessage);
    }
  };

  // 계좌번호 인풋박스 가이드 메시지
  const getCheckAccountMsg = useCallback(
    (accountCheckCode, accountCheckMessage = '') => {
      switch (accountCheckCode) {
        case '0':
        case '3':
          return '납부계좌 정보가 확인되었습니다.';
        case '1':
        case '2':
          return '계좌의 유효성 체크가 불가합니다. 청약진행은 가능하나 해당계좌로 즉시출금이 불가할 수 있으니 참고 바랍니다.';
        case '4':
          return '은행업무 외 시간으로 계좌의 유효성 체크가 불가합니다. 청약진행은 가능하나 해당계좌로 즉시출금이 불가할 수 있으니 참고 바랍니다.';
        case '5':
          return '은행으로부터 응답이 지연되고 있습니다. 잠시 후 다시 시도해 주십시오.';
        case '6':
          return `계좌의 유효성 체크에 실패하였습니다. ${
            accountCheckMessage ? `(${accountCheckMessage})` : ''
          }`;
        default:
          return '계좌의 유효성 체크가 불가합니다. 청약진행은 가능하나 해당계좌로 즉시출금이 불가할 수 있으니 참고 바랍니다.';
      }
    },
    [],
  );

  // 저장버튼 클릭
  const handleButtonClick = () => {
    if (
      // !accountType ||
      !bankInfo.code ||
      !accountNumber ||
      !checkAccount ||
      ['5', '6'].includes(accountCheckCode) ||
      questionData.includes('N') ||
      questionData.includes('') ||
      !signNameData ||
      !signatureData
    ) {
      if (accountNumber.length < 5) {
        accountNumberInputRef.current.isValidCheck();
      } else if (!checkAccount) {
        dispatch(
          showModal({
            visible: true,
            type: 'info',
            msg: '먼저 계좌확인을 진행해주세요.',
          }),
        );
      }
      setShowErrorCheckMsg(true);
    } else {
      // 저장
      onSave({
        // accountType,
        payerName,
        payerRsdn,
        bankInfo,
        accountNumber,
        signNameData,
        signatureData,
        reportId,
        signId: 'app_form_09_signid_02',
        nameId: 'app_form_09_signid_01',
      });
    }
  };

  const questionList = [
    '1. 전환 후 계약의 가입제안서, 청약서부본을 수령하시고, 전환 전 계약 및 전환 후 계약의 보장내용에 대한 차이를 설명 받으셨습니까?',
    '2. 전환시 보험료, 배당유무 및 적용이율 변경 등으로 계약자에게 불리할 수도 있음를 설명 받으셨습니까?',
    '3. 전환신청된 계약의 정기성보험/특약은 전환 후 계약이 승낙되는 경우에만 전환처리(전환 후 계약 청약일 기준 해약/감액)됨을 설명 받으셨습니까?',
    '4. 전환 후 계약 및 특약의 보장개시일은 전환 후 계약의 청약일로부터 개시되며, 전환일 기준 약관이 적용됨를 설명 받으셨습니까?',
    '5. 전환 후 계약의 보험료는 전환 후 계약의 청약일 기준 피보험자 연령으로 산출됨를 설명 받으셨습니까?',
    '6. 전환 전에 발생한 재해/질병으로 인해 전환 이후에 납입면제 장해상태가 된 경우에는 보험료 납입면제 되지 않을 수 있음를 설명 받으셨습니까?',
    '7. [전환 전 계약이 납입면제인 경우 해당] 전환시 전환 후 계약은 보험료 납입을 면제하여 드리지 않음를 설명 받으셨습니까?',
    '8. [전환 전 계약의 일부를 전환할 경우 해당] 전환 후 계약이 유지되지 않을 경우, 전환 전 계약의 특약한도에 영향을 줄 수 있음을 설명 받으셨습니까?',
  ];

  // const handleRadioButton = value => {
  //   if (value === '2') {
  //     // 기타계좌로 변경 시 기존 자동이체 계좌 정보 날림
  //     setBankInfo([]);
  //     setAccountNumber('');
  //     setAccountCheckCode('');
  //     setAccountCheckMessage('');
  //   } else {
  //     // 자동이체 계좌로 변경 시 자동이체 계좌 셋팅
  //     setBankInfo({ code: planInfoBankCode, name: planInfoBankName });
  //     setAccountNumber(planInfoAccountNo);
  //   }
  //   setCheckAccount(null);
  //   setAccountType(value);
  // };

  return (
    <React.Fragment>
      <header className="con-header">
        `
        <div className="page-navi">
          <SatButton
            styleClass={`btn-back`}
            label={'이전'}
            onClick={() => onClose()}
          />
        </div>
        <h1 className="page-tit">종신전환 신청서</h1>
      </header>

      <div className="con-wrap" id="signPadScroll">
        <div className="pop-box">
          <div className="infor-list pdb-20">
            {/*<h2 className="tit-con">전환전 계약의 지급액 발생시 송금은행</h2>*/}
            {/*<div className="check-box">*/}
            {/*  <SatRadio*/}
            {/*    name="accountType"*/}
            {/*    value={accountType}*/}
            {/*    options={[*/}
            {/*      { label: '전환전 계약의 자동이체계좌', value: '1' },*/}
            {/*      { label: '기타 계좌', value: '2' },*/}
            {/*    ]}*/}
            {/*    onChange={value => handleRadioButton(value.value)}*/}
            {/*  />*/}
            {/*</div>*/}

            <h2 className="tit-con">받으실 계좌</h2>
            <div className="mgt-0">
              <SatValidationErrMsg
                visible={true}
                type="info"
                message="본인명의의 다른 계좌로만 가능합니다."
              />
            </div>
            <div className="box two item-r2">
              <SatInput label={'성명'} readOnly value={payerName} />

              <div className="item-number">
                <SatInput
                  value={payerRsdn && payerRsdn.substr(0, 6)}
                  type="text"
                  label="예금주 주민등록번호"
                  readOnly
                  bold
                />
                <span className="hypen">-</span>
                <SatInput
                  value={payerRsdn && payerRsdn.substr(6, 1)}
                  type="text"
                  label="주민번호 뒤7자리"
                  readOnly
                  bold
                />
              </div>
            </div>
            <div className="box two item-r2 a-fs">
              <div className="item-w50 flex-column">
                <SatSelect
                  title={'거래은행'}
                  value={bankInfo.code ? bankInfo.code : ''}
                  initOption={{ label: '선택', value: '' }}
                  options={bankList.map(item => {
                    return { label: item.bankName, value: item.bankCode };
                  })}
                  onChange={item => {
                    bankCodeValid &&
                      item.value !== '' &&
                      setBankCodeValid(false);
                    setBankInfo({ code: item.value, name: item.label });
                    setCheckAccount(false);
                    setAccountCheckCode('');
                    setAccountCheckMessage('');
                  }}
                  // readOnly={
                  //   // accountType === '1' && bankInfo.code && bankInfo.code !== ''
                  //   bankInfo.code && bankInfo.code !== ''
                  // }
                />
                <SatValidationErrMsg
                  visible={
                    showErrorCheckMsg && (bankCodeValid || !bankInfo.code)
                  }
                  type={'error'}
                  message={'거래은행을 선택해주세요.'}
                />
              </div>
              <div className="item-w50 inp-outbox block">
                <SatInput
                  ref={accountNumberInputRef}
                  type="number"
                  label={'계좌번호'}
                  value={accountNumber}
                  outerSuffix={() => (
                    <button
                      type="button"
                      className={`btn-s b-blue area-in-btn ${
                        bankInfo.code === '' || accountNumber.length < 5
                          ? 'disabled'
                          : ''
                      }`}
                      onClick={onClickAccountValidEvent}
                    >
                      계좌확인
                    </button>
                  )}
                  validRule={[
                    {
                      rule: v => v.length >= 5,
                      errMsg: '계좌번호를 5자리 이상 입력해주세요.',
                    },
                    {
                      required: accountNumber.length < 5,
                      errMsg: '계좌번호를 입력해주세요.',
                    },
                    {
                      rule: _ => {
                        return checkAccount && ['5'].includes(accountCheckCode)
                          ? false
                          : true;
                      },
                      errMsg:
                        '은행으로부터 응답이 지연되고 있습니다. 잠시 후 다시 시도해 주십시오.',
                    },
                    {
                      rule: _ => {
                        return checkAccount && ['6'].includes(accountCheckCode)
                          ? false
                          : true;
                      },
                      errMsg: `계좌의 유효성 체크에 실패하였습니다. ${
                        accountCheckMessage ? `(${accountCheckMessage})` : ''
                      }`,
                    },
                  ]}
                  onChange={value => {
                    setCheckAccount(false);
                    setAccountCheckCode('');
                    setAccountCheckMessage('');
                    setAccountNumber(value);
                  }}
                  // readOnly={accountType === '1' && accountNumber !== ''}
                  // readOnly={accountNumber !== ''}
                />
                <SatValidationErrMsg
                  visible={
                    checkAccount
                    //&& !['5', '6'].includes(accountCheckCode)
                  }
                  type={
                    !['5', '6'].includes(accountCheckCode) ? 'check' : 'error'
                  }
                  message={getCheckAccountMsg(
                    accountCheckCode,
                    accountCheckMessage,
                  )}
                />
              </div>
            </div>
          </div>

          <div className="infor-list no-line">
            <h2 className="tit-con">전환시 주요확인사항</h2>
            <div className="insu-box">
              <div className="txt-question">
                <p>확인 후 해당란에 체크 및 서명해주세요.</p>
              </div>
              <div className="inp-list2">
                <SatCheckBox
                  value={[checkAll]}
                  options={[{ label: '전체 확인 및 동의', value: true }]}
                  onChange={v => {
                    setCheckAll(v);
                    setQuestionData(
                      Array(questionList.length).fill(v ? 'Y' : ''),
                    );
                  }}
                />
              </div>
            </div>
            {questionList.map((option, index) => {
              return (
                <>
                  <SatQuestionArea
                    title={() => <p>{option}</p>}
                    selectValue={questionData[index]}
                    options={[
                      { label: '예', value: 'Y' },
                      { label: '아니오', value: 'N' },
                    ]}
                    useType={'checkBox'}
                    onClick={(checkValue, optionValue) =>
                      checkValue && handleCheckBox(index, optionValue)
                    }
                    listType="inp-list2 input-space"
                  />
                </>
              );
            })}
            <SatValidationErrMsg
              visible={
                showErrorCheckMsg &&
                (questionData.includes('N') || questionData.includes(''))
              }
              type={'error'}
              message={'주요확인사항을 확인 후 동의하여야 신청이 가능합니다.'}
            />
          </div>
          <div className="info-box bg-yellow">
            <p className="text-info3">
              본인은 상기의 [종신전환 신청서]에 기재된 모든 사항을 직접
              확인하고, 중요 내용을 정확히 숙지하였으며, 전환 후 보험약관에 의거
              전환을 신청합니다.
            </p>
          </div>
          <SatCheckBox
            value={[pasteCheck]}
            type={'radio'}
            options={[
              { label: '저장했던 성명/서명을 붙여넣으세요.', value: false },
            ]}
            onChange={v => handlePasteCheck(v)}
            customStyleClass="small w-360"
          />

          <div className="sign-pad-wrap">
            <SatSignPad
              CancelRefundMainContract
              canvasRef={canvasSignNameRef}
              name={payerName}
              title={'계약자 성명 입력'}
              error={
                showErrorCheckMsg && !signNameData ? '성명을 입력해주세요.' : ''
              }
              pasteCheck={pasteCheck}
              pasteData={
                !isPracticeMode
                  ? signPasteData.app_form_etc_18_sign_01
                  : practiceSignName
              }
              signData={complete ? signData.app_form_09_signid_02 : ''}
              onChange={data => setSignNameData(data)}
              onChangePasteCheck={value => setPasteCheck(value)}
            />

            <SatSignPad
              canvasRef={canvasSignatureRef}
              name={'서명'}
              title={'계약자 서명 입력'}
              error={
                showErrorCheckMsg && !signatureData
                  ? '서명을 입력해주세요.'
                  : ''
              }
              pasteCheck={pasteCheck}
              pasteData={
                !isPracticeMode
                  ? signPasteData.app_form_etc_18_sign_02
                  : practiceSignature
              }
              signData={complete ? signData.app_form_09_signid_01 : ''}
              onChange={data => setSignatureData(data)}
              onChangePasteCheck={value => setPasteCheck(value)}
            />
          </div>
        </div>
      </div>

      <div className="con-bottom box-shadow">
        <div className="btn-area">
          <div className="box-btns-center">
            <SatButton
              styleClass={`btn-s blue btn-wide ${
                // !accountType ||
                !bankInfo.code ||
                !accountNumber ||
                !checkAccount ||
                ['5', '6'].includes(accountCheckCode) ||
                questionData.includes('N') ||
                questionData.includes('') ||
                !signNameData ||
                !signatureData
                  ? 'disabled'
                  : ''
              }`}
              label={'확인'}
              onClick={() => handleButtonClick()}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PolicyConversionPopup;
